import { render } from "./Tags.vue?vue&type=template&id=3f5a7392&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=3f5a7392&scoped=true&lang=scss"
import "./Tags.vue?vue&type=style&index=1&id=3f5a7392&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a7392"]])

export default __exports__